import {all, put, putResolve, select, takeEvery} from "redux-saga/effects";
import {regApi} from "./reg_api";
import {newError, Severity} from "../errors/errors";
import {RootState} from "../../store";
import {OperationApiGet} from "../operation/operation_api";
import {GetApiResponse, IdResult, PostApiResponse, UpdateResp} from "../../api";
import {Action, PayloadAction} from "@reduxjs/toolkit";
import {clearScancode, processScan} from "./reg_reducer";
import {QueryReturnValue} from "@reduxjs/toolkit/query";
import {supabase} from "../../supabase";
import {PostgrestError} from "@supabase/supabase-js";


function* onProcessScan({payload}: PayloadAction<number>) {

    const id: number = payload
    const code: string = yield select((s: RootState) => s.reg?.scancode)

    yield put(clearScancode());

    if (code == "") {
        return
    }

    const {data, error}: {
        data?: IdResult,
        error: PostgrestError
    } = yield supabase.from('worker').select("id").eq("code", code).maybeSingle()

    if (error) {
        yield put(newError({message: error.message, severity: Severity.Error}));
        return
    }

    if (data) {
        const regWorkResp: QueryReturnValue<GetApiResponse<OperationApiGet[]>, any, void> =
            yield putResolve(regApi.endpoints.putRegistrationById.initiate({id, body: {WorkerID: data.id,}}));

        if ("error" in regWorkResp) {
            yield put(newError({message: regWorkResp.error.data.message, severity: Severity.Error}));
        }
        return
    }


    {
        const {data, error}: {
            data?: IdResult,
            error: PostgrestError
        } = yield supabase.from('workTask').select("id").eq("Code", code).maybeSingle()
        if (error) {
            yield put(newError({message: error.message, severity: Severity.Error}));
            return
        }
        if (data) {
            const regWorkResp: QueryReturnValue<UpdateResp, any, void> =
                yield putResolve(regApi.endpoints.putRegistrationById.initiate({
                    id, body: {OperationID: data.id}
                }) as unknown as Action);
            if ("error" in regWorkResp) {
                yield put(newError({
                    message: regWorkResp.error?.data?.message || "internal error",
                    severity: Severity.Error
                }));
                return
            }
            return
        }
    }


    // search machine
    {
        const {data, error}: {
            data?: IdResult,
            error: PostgrestError
        } = yield supabase.from('machine').select("id").eq("Code", code).maybeSingle()
        if (error) {
            yield put(newError({message: error.message, severity: Severity.Error}));
            return
        }
        if (data) {
            const regWorkResp: QueryReturnValue<UpdateResp, any, void> =
                yield putResolve(regApi.endpoints.putRegistrationById.initiate({
                    id, body: {MachineID: data.id}
                }) as unknown as Action);
            if ("error" in regWorkResp) {
                yield put(newError({
                    message: regWorkResp.error?.data?.message || "internal error",
                    severity: Severity.Error
                }));
                return
            }
            return
        }
    }

    {
        const {data, error}: {
            data?: IdResult,
            error: PostgrestError
        } = yield supabase
            .from('workOrder')
            .select("id")
            .eq("number", code)
            .in("status", [
                "PreparedForProduction",
                "InProduction",
                "SendingForProduction",
                "ApprovedForProduction",
            ])
            .maybeSingle()

        if (error) {
            yield put(newError({message: error.message, severity: Severity.Error}));
            return
        }
        if (data) {
            const regResp: QueryReturnValue<PostApiResponse, any, void> = yield putResolve(regApi.endpoints.putRegistrationById.initiate({
                id, body: {WorkOrderID: data.id}
            }))
            if ("error" in regResp) {
                yield put(newError({
                    message: regResp.error?.data?.message || "internal error",
                    severity: Severity.Error
                }));
                return
            }
            return
        }
    }

    yield put(newError({message: "Invalid code", severity: Severity.Error}));
}


export function* reg_saga() {
    yield all([
        takeEvery(processScan, onProcessScan),
    ]);
}
